Livewire.on('showAlert', () => {

    setTimeout( () => {
        const alert = document.querySelector('#livewire-alert')
        console.log(alert)
        alert.remove()
    }, 2000)
})

Livewire.on('setSelectQueryAutoFocus', (name) => {
    wraper = document.getElementById('search-wraper-'+name);
    if (wraper) {
        input = wraper.getElementsByClassName("input")[0];
        input.focus();
    }

})


window.addEventListener("keydown",  function(event) {

    if (event.keyCode === 13) {
        Livewire.emit('pressEnter');
    }
});


Livewire.on('copyToClipboard', ($text) => {
    console.log($text);

    navigator.clipboard.writeText($text).then(() => {
        console.log('Content copied to clipboard');
      },() => {
        console.error('Failed to copy');
      });
});

window.showMoreOrderInfo = function showMoreOrderInfo($id)
{
    Livewire.emit('showMoreOrderInfo', $id);
}

window.openModalManageProduct = function openModalManageProduct($id)
{
    console.log('manage product ' + $id);
    window.livewire.emit('openModalRejectProduct', $id);
}
